import React from "react";

import client01 from "../../../assets/clients/client_01.png";
import client02 from "../../../assets/clients/client_02.png";
import client03 from "../../../assets/clients/client_03.png";
import client04 from "../../../assets/clients/client_04.png";
import client05 from "../../../assets/clients/client_05.png";
import client06 from "../../../assets/clients/client_06.png";
import client07 from "../../../assets/clients/client_07.png";
import client08 from "../../../assets/clients/client_08.png";
import client09 from "../../../assets/clients/client_09.png";
import client10 from "../../../assets/clients/client_10.png";
import client11 from "../../../assets/clients/client_11.png";
import client12 from "../../../assets/clients/client_12.png";
import { Reveal } from "../../../components/common";

const clients = [
    { name: "Client 01", logo: client01 },
    { name: "Client 02", logo: client02 },
    { name: "Client 03", logo: client03 },
    { name: "Client 04", logo: client04 },
    { name: "Client 05", logo: client05 },
    { name: "Client 06", logo: client06 },
    { name: "Client 07", logo: client07 },
    { name: "Client 08", logo: client08 },
    { name: "Client 09", logo: client09 },
    { name: "Client 10", logo: client10 },
    { name: "Client 11", logo: client11 },
    { name: "Client 12", logo: client12 },
];

const ClientsSection = () => {
    return (
        <section className="bleed border-y border-designer-dark/10">
          <div className="container-responsive py-12 md:py-16">
            <Reveal>
                <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-8 md:mb-10">
                    <div>
                        <div className="flex items-center gap-3">
                            <span className="tick" aria-hidden="true" />
                            <p className="text-xs font-bold tracking-[0.25em] uppercase text-designer-primary">
                                Our clients
                            </p>
                        </div>
                        <h2 className="mt-3 font-display font-extrabold tracking-tight text-2xl sm:text-3xl text-designer-dark">
                            Trusted by forward-thinking brands
                        </h2>
                    </div>
                    <p className="font-mono text-xs tracking-[0.22em] text-gray-400 uppercase shrink-0">
                        85+ and counting
                    </p>
                </div>
            </Reveal>

            <div
                className="marquee-paused relative overflow-hidden [mask-image:linear-gradient(90deg,transparent,black_8%,black_92%,transparent)]"
                role="list"
                aria-label="Client logos"
            >
                <div className="marquee-track flex items-center gap-14 py-4 pr-14">
                    {[...clients, ...clients].map((client, idx) => (
                        <div key={idx} role="listitem" className="flex-shrink-0" aria-hidden={idx >= clients.length}>
                            <img
                                src={client.logo}
                                alt={idx < clients.length ? `${client.name} logo` : ""}
                                loading="lazy"
                                decoding="async"
                                className="h-12 md:h-14 w-auto max-w-[180px] object-contain grayscale opacity-50 transition-all duration-300 hover:-translate-y-1.5 hover:scale-125 hover:grayscale-0 hover:opacity-100 hover:drop-shadow-lg"
                            />
                        </div>
                    ))}
                </div>
            </div>
          </div>
        </section>
    );
};

export default ClientsSection;
